import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

function ProfileButton() {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.currentUser);

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const profileImage = currentUser?.profileImageUrl || '';
  const hasProfileImage = !!profileImage;
  const initials = currentUser?.name ? getInitials(currentUser.name) : '';

  return (
    <button
      onClick={() => navigate('/profile')}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '2px solid #ccc',
        padding: 0,
        overflow: 'hidden',
        backgroundColor: hasProfileImage
          ? '#eee'
          : 'var(--color-secondary)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
      }}
      aria-label="Go to profile"
    >
      {hasProfileImage ? (
        <img
          src={profileImage}
          alt="Profile"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <span>{initials}</span>
      )}
    </button>
  );
}

export default ProfileButton;